import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';

import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import EnterpriseLink from '#client/components/EnterpriseLink';
import { VeloAssistantButton } from '#client/components/VeloAssistantButton';
import { ENABLE_VELO_ASSISTANT, VELO_REPLACE_NEXT_UP_CARDS } from '#client/constants/experimentsFlags';
import { useAccountExperience } from '#client/hooks/useAccountExperience';

import * as Styled from './AppHeader.style';
import { useDrawerState } from '../../hooks/useDrawerState';
import { Logo } from '../Logo';
import { UserMenu } from '../UserMenu';

const AppHeader = () => {
  const { drawerState, toggleDrawer } = useDrawerState();

  const isVeloAssistantEnabled = useExperimentFlag(
    ENABLE_VELO_ASSISTANT,
    false
  );
  const isVeloNextUpEnabled = useExperimentFlag(
    VELO_REPLACE_NEXT_UP_CARDS,
    false
  );
  const { accountExperience, enterprise } = useAccountExperience();
  const { chrome } = accountExperience;

  // Hide the Ask Velo button when VeloChat is shown on the dashboard
  const showVeloAssistantButton = isVeloAssistantEnabled
    && !isVeloNextUpEnabled
    && chrome.showVeloAssistant;
  const veloAssistantClickstreamProps = {
    appSection: 'velo-chat',
    elementName: 'ask_velo',
    elementText: 'Ask Velo',
    dynamicProperties: {
      ai_project_name: 'velo_chat'
    }
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Styled.Root>
      <Styled.DrawerButton
        clickstreamProps={{
          elementAsset: drawerState ? '/s2/icon/e-remove-outline.svg' : '/s2/icon/zb-menu-outline.svg',
          elementName: 'app_header_toggle'
        }}
        label={drawerState ? 'Close drawer' : 'Open drawer'}
        icon={drawerState ? <CloseIcon /> : <MenuIcon />}
        onClick={toggleDrawer}
        open={drawerState}
        tabIndex={0}
      />

      <Styled.LogoContainer data-testid="logo-container">
        {showVeloAssistantButton && isMobile
          ? <VeloAssistantButton clickstreamProps={veloAssistantClickstreamProps} />
          : <Logo />}
      </Styled.LogoContainer>

      <Styled.UserMenuContainer>
        <Stack direction="row" spacing={1}>
          {chrome.showEnterpriseLink ? (
            <EnterpriseLink enterprise={enterprise} />
          ) : (
            showVeloAssistantButton
            && !isMobile
            && (
              <VeloAssistantButton
                variant="outlined"
                color="primary"
                clickstreamProps={veloAssistantClickstreamProps}
              />
            )
          )}
          <UserMenu />
        </Stack>
      </Styled.UserMenuContainer>
    </Styled.Root>
  );
};

export default AppHeader;
